/* BSP30 (Half-Life): Fassade für die Teilmodule.
 *   bsp-parse.ts   Datei lesen (Lumps, Geometrie, Texturen)
 *   bsp-scene.ts   Aufbereitung für die Darstellung (Polygone, Lightmap-Atlas)
 *   bsp-write.ts   Entity-/Textur-Lump austauschen
 *   zip.ts         ZIP ohne Kompression, CRC-32 */
import { faceVerts, LUMP, parse } from './bsp-parse.ts';
import { scene } from './bsp-scene.ts';
import { entsToText, withEntities } from './bsp-write.ts';
import { crc32, zip } from './zip.ts';

const Bsp = { parse, scene, entsToText, withEntities, zip, crc32, faceVerts, LUMP };
export default Bsp;
export type { BspFile, BspFace, BspModel, BspTexInfo, BspTexture, BspLump } from './bsp-parse.ts';
export type { BspScene, ScenePoly, LightAtlas } from './bsp-scene.ts';
export type { TexReplacement } from './bsp-write.ts';
